import { createSlice } from '@reduxjs/toolkit'
import {getFacultyBankDetails, getFacultyProfile, getFacultyProfilePhoto, updateFacultyProfilePhoto } from '../../builders/facultyProfile/facultyProfile.builder'

const initialState = {
  FacultyProfileInfo: [],
  facultyBankDetails:[],
  facultyProfilePhoto: null,
  loading: false,
}

const facultyProfileSlice = createSlice({
  name: 'facultyProfile',
  initialState,
  reducers: {
    clearExtraReducers: (state) => {
      state.loading = false
      state.facultyProfilePhoto = null
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getFacultyProfile.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getFacultyProfile.fulfilled, (state, action) => {
      state.loading = false
      state.FacultyProfileInfo = action.payload
    })
    builder.addCase(getFacultyProfile.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getFacultyBankDetails.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getFacultyBankDetails.fulfilled, (state, action) => {
      state.loading = false
      state.facultyBankDetails = action.payload
    })
    builder.addCase(getFacultyBankDetails.rejected, (state) => {
      state.loading = false
    })

    {/* this Edit bank details model for now no required  as per discussion we commented this code     */}
  
    // builder.addCase(editFacultyBankDetail.pending, (state, action) => {
    //   state.loading = true
    // })
    // builder.addCase(editFacultyBankDetail.fulfilled, (state, action) => {
    //   state.loading = false
    // })
    // builder.addCase(editFacultyBankDetail.rejected, (state, action) => {
    //   state.loading = false
    // })
    builder.addCase(getFacultyProfilePhoto.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getFacultyProfilePhoto.fulfilled, (state, action) => {
      state.loading = false
      state.facultyProfilePhoto = action.payload
    })
    builder.addCase(getFacultyProfilePhoto.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(updateFacultyProfilePhoto.pending, (state) => {
      state.loading = true
    })
    builder.addCase(updateFacultyProfilePhoto.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(updateFacultyProfilePhoto.rejected, (state) => {
      state.loading = false
    })
  },
})

export const {facultyProfilePhoto  } = facultyProfileSlice.actions
export default facultyProfileSlice.reducer
